module.exports = __webpack_public_path__ + "static/img/Bingjie_YU.4f3582c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Bingjie_YU.png
// module id = /EGR
// module chunks = 1